import { createAsyncThunk } from "@reduxjs/toolkit";
import { postRequest } from "../../services/API";


const FETCH_LOGIN_DETAILS = "loginAction";

export const loginAction = createAsyncThunk(
  FETCH_LOGIN_DETAILS,
  async (
    { language, isAdmin, email, password, customTost = false },
    { rejectWithValue }
  ) => {
    try {
      let userInfo = {
        username: email,
        password: password,
      };
      let loginResult = await postRequest(
        language,
        isAdmin ? "adminLogin" : "login",
        userInfo,
        isAdmin,
        customTost
      );

      if (loginResult && loginResult.data) {
        // Login data available but no processing needed
      }

      return loginResult;
    } catch (error) {
      return rejectWithValue(JSON.parse(error.message));
    }
  }
);
